@let application = result();

<soft-search-result-item
  [icon]="application?.icon || 'fa-regular fa-ban'"
  [title]="($safeNavigationMigration(application?.name) | translate) ?? ''"
  [muted]="!!application?.disabled"
  (click)="openApplication(application)"
>
  @if (application?.type === 'link') {
    <span
      searchResultTrailing
      class="text-[9px] font-medium bg-surface-secondary text-light rounded-full px-1.5 py-px shrink-0 flex items-center gap-0.5"
    >
      <i class="fa-regular fa-arrow-up-right-from-square text-[9px]"></i>
      Externer Link
    </span>
  }
  @if (canPin()) {
    <button
      searchResultTrailing
      type="button"
      class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-7 rounded-md hover:bg-surface-tertiary transition-opacity shrink-0 cursor-pointer"
      [class.opacity-100]="isPinned()"
      (click)="togglePin($event)"
      [title]="isPinned() ? 'Aus Navigation entfernen' : 'An Navigation anheften'"
    >
      <i
        class="fa-thumbtack text-xs transition-transform"
        [class.fa-solid]="isPinned()"
        [class.fa-regular]="!isPinned()"
        [class.text-primary]="isPinned()"
        [class.rotate-45]="isPinned()"
      ></i>
    </button>
  }
  <button
    searchResultTrailing
    type="button"
    class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-7 rounded-md hover:bg-surface-tertiary transition-opacity shrink-0 cursor-pointer"
    (click)="openInNewTab(application, $event)"
    title="In neuem Tab öffnen"
  >
    <i class="fa-regular fa-arrow-up-right-from-square text-xs"></i>
  </button>
</soft-search-result-item>
